import React from "react";
import { currencies, periods, sizeUnits } from "_constants";
import { Field } from "formik";
import DropdownField from "forms/fields/DropdownField";
import RenderField from "forms/fields/RenderField";
import PropTypes from "prop-types";

import Translate from "utils/translate";

import formStyles from "forms/forms.css";
import styles from "./BudgetField.css";

const { t } = new Translate();

const BudgetField = ({ field: { name }, label, showUnit }) => (
  <div className={formStyles.field}>
    <label>{label}</label>
    <div className={styles.root}>
      <Field component={RenderField} name={`${name}.from`} />
      <small className={styles.separator}>{t("to")}</small>
      <Field component={RenderField} name={`${name}.to`} />
      <Field
        component={DropdownField}
        name={`${name}.currency`}
        valueExtractor={(c) => t(`units.${c}`)}
        values={currencies}
      />
      {showUnit && (
        <Field
          component={DropdownField}
          linkingWord={t("per")}
          name={`${name}.unit`}
          valueExtractor={(p) => t(`units.${p}`)}
          values={sizeUnits}
        />
      )}
      <Field
        component={DropdownField}
        linkingWord={t("per")}
        name={`${name}.period`}
        valueExtractor={(u) => t(`units.${u}`)}
        values={Object.keys(periods)}
      />
    </div>
  </div>
);

BudgetField.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
  }),
  label: PropTypes.string,
  showUnit: PropTypes.bool,
};

BudgetField.defaultProps = {
  label: t("budget"),
  showUnit: true,
};

export default BudgetField;
